module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_function-to-string.js
// module id = 174
// module chunks = 36